import _extends from "@babel/runtime/helpers/esm/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import React from 'react';
import { getRem } from "../../core";
import styled, { keyframes } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
var animationDuration = '1.5s';
var spinnerSize = '20px';
var rotateSpinner = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    100% {\n        transform: rotate(360deg);\n    }\n"])));
var spinnerDash = keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    0% {\n        stroke-dasharray: 1px, 200px;\n        stroke-dashoffset: 0;\n    }\n\n    50% {\n        stroke-dasharray: 100px, 200px;\n        stroke-dashoffset: -15px;\n    }\n\n    100% {\n        stroke-dasharray: 100px, 200px;\n        stroke-dashoffset: -125px;\n    }\n"])));
var StyledCircle = styled.circle(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  animation: ", " ", " ease-in-out infinite;\n  stroke-dasharray: 80px 200px;\n  stroke-dashoffset: 0;\n  transform-origin: center;\n"])), spinnerDash, animationDuration);
var StyledSpinner = styled.svg(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  animation: ", " ", " linear infinite;\n  flex-shrink: 0;\n  height: ", ";\n  stroke-width: 4px;\n  stroke: inherit;\n  width: ", ";\n"])), rotateSpinner, animationDuration, getRem(spinnerSize), getRem(spinnerSize));
export var StyledLoaderSpinner = function StyledLoaderSpinner(_ref) {
  var other = _extends({}, _ref);

  return /*#__PURE__*/_jsx(StyledSpinner, {
    viewBox: "0 0 50 50",
    children: /*#__PURE__*/_jsx(StyledCircle, {
      className: "path",
      cx: "25",
      cy: "25",
      r: "20",
      fill: "none"
    })
  });
};
StyledLoaderSpinner.displayName = "StyledLoaderSpinner";
StyledLoaderSpinner.propTypes = {};
StyledLoaderSpinner.defaultProps = {};